import { Table, Text } from '@nimbus-ds/components';

function Skeleton() {
  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.Cell backgroundColor="neutral-surface" as="th">
            <Text.Skeleton width="100px" />
          </Table.Cell>
          <Table.Cell backgroundColor="neutral-surface" as="th">
            <Text.Skeleton width="100px" />
          </Table.Cell>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Text.Skeleton width="100px" />
          </Table.Cell>
          <Table.Cell>
            <Text.Skeleton width="100px" />
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}

export default Skeleton;
